<script setup lang="ts">
import { computed } from "vue";
import { ASSOCIATION_WEBSITE_URL } from "@evka/shared";

/**
 * Refusal states of the buy page (SPEC §8.1): the event website may still
 * link here after sales stopped, so each state explains itself and offers
 * the way back to the website.
 *  - `over`: event day has passed (automatic).
 *  - `ended`: admin ended the Vorverkauf permanently → Abendkasse hint.
 *  - `paused`: admin paused temporarily → "come back soon".
 *  - `inactive`: event not (yet) published — the pre-existing generic text.
 */
const props = defineProps<{
  variant?: "inactive" | "paused" | "ended" | "over";
}>();

const keys = computed(() => {
  const v = props.variant ?? "inactive";
  return {
    title: `buy.unavailable.${v}.title`,
    message: `buy.unavailable.${v}.message`,
  };
});
</script>

<template>
  <div class="mx-auto max-w-xl px-4 py-8">
    <h1 class="text-xl font-semibold text-slate-900">
      {{ $t(keys.title) }}
    </h1>
    <p class="mt-3 rounded-md border border-slate-200 bg-slate-50 px-4 py-3 text-slate-700">
      {{ $t(keys.message) }}
    </p>
    <a
      :href="ASSOCIATION_WEBSITE_URL"
      class="mt-5 inline-block rounded-md bg-slate-800 px-4 py-2 text-sm font-semibold text-white hover:bg-slate-700"
      data-testid="back-to-website"
    >
      {{ $t("buy.unavailable.backToWebsite") }}
    </a>
  </div>
</template>
